module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-500-[58]301.b9df367.woff2";